import React from 'react'
import PropTypes from 'prop-types'
import { Label, Table, Loader } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import { CRUDIndex } from '../CRUD'
import { EditDeleteButtonContainer } from '../../containers'
import { formatDate } from '../../utils/formats'

const VigenciaParametro = props => {
  return (
    <CRUDIndex
      noTitle
      padded={false}
      onRedirectToNew={props.onRedirectToNew}
      onExportToCSV={props.onExportToCSV}
      filterText={props.filterText}
      handleFilter={props.handleFilter}>
      <Table sortable celled striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              width={1}
              textAlign='center'
              onClick={props.handleSort('id')}
              sorted={props.handleSorted('id')}>
              #
            </Table.HeaderCell>
            <Table.HeaderCell
              onClick={props.handleSort('starts_at')}
              sorted={props.handleSorted('starts_at')}>
              Início da Vigência
            </Table.HeaderCell>
            <Table.HeaderCell width={1}></Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {props.isLoading && (
            <Table.Row>
              <Table.Cell colSpan={4}>
                <Loader active={props.isLoading} inline='centered' />
              </Table.Cell>
            </Table.Row>
          )}

          {props.multipleVigenciaParametro
            .valueSeq()
            .map((vigenciaParametro, index) => {
              return (
                <Table.Row key={index}>
                  <Table.Cell textAlign='center'>
                    <Label
                      as={Link}
                      to={`/instalacoes/${vigenciaParametro.getIn([
                        'instalacao',
                        'id',
                      ])}/parametros/${vigenciaParametro.get('id')}`}>
                      {vigenciaParametro.get('id')}
                    </Label>
                  </Table.Cell>
                  <Table.Cell>
                    {formatDate(vigenciaParametro.get('starts_at'))}
                  </Table.Cell>
                  <Table.Cell>
                    <EditDeleteButtonContainer
                      onEditResource={() =>
                        props.onEditResource(
                          vigenciaParametro.getIn(['instalacao', 'id']),
                          vigenciaParametro.get('id')
                        )
                      }
                      onDeleteResource={() =>
                        props.onDeleteResource(vigenciaParametro.get('id'))
                      }
                    />
                  </Table.Cell>
                </Table.Row>
              )
            })}
        </Table.Body>
      </Table>
    </CRUDIndex>
  )
}

VigenciaParametro.propTypes = {
  onRedirectToNew: PropTypes.func,
  multipleVigenciaParametro: PropTypes.object,
  onEditResource: PropTypes.func,
  onDeleteResource: PropTypes.func,
  handleSort: PropTypes.func,
  handleSorted: PropTypes.func,
  filterText: PropTypes.string,
  handleFilter: PropTypes.func,
  onExportToCSV: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default VigenciaParametro
